<template>
  <div class="message card card-body" :class="bgclass" v-show="message.showMessage" style="position :absolute !1important; ">

    <!-- message header -->
    <div class="message-header mt-2">
      {{ message.title }}
      <button class="close" @click="close">
        <font-awesome-icon icon="times" />
      </button>
    </div>
    <hr style="color:white !important">
    <!-- message body -->
    <div class="message-body mb-3 bg-transparent d-flex">
      <p>
        <span class="text-light" style="font-size:12px">{{ message.body }}</span>
      <ul>
        <li v-for="(errors, item) in message.itemsErrors" :key="item">
          <u>{{ item }}</u> :
          <ul v-for="error in errors" :key="error">
            {{ error }}
          </ul>
        </li>
      </ul>
      </p>

      <button v-if="message.confirm" @click="proceed" class="btn btn-sm"
        :class="[{'disabled': message.waiting}, btnclass]">
        <template v-if="message.waiting">
          <font-awesome-icon icon="spinner" pulse />
        </template>
        <template v-else>
          Proceed
        </template>
      </button>

      <span class="clearfix"></span>
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      message: function () {
        return this.$store.getters["message/structure"];
      },
      bgclass: function () {
        return "bg-" + this.message.class;
      },
      btnclass: function () {
        return "btn-" + this.message.class;
      },
    },

    methods: {
      close: function () {
        this.$store.dispatch("message/close");
        this.$bus.$off("proceed");
      },

      proceed: function () {
        this.$bus.$emit("proceed");
        this.waiting = true;
      },
    },
  };
</script>
<style scoped>
 .btn:hover{
    color: #266aa2 !important;
  }
  .message{
    position: fixed;
  }
  button.btn.btn-sm.btn-success {
    color: #266aa2 !important;
  }

@media (min-width: 320px) and (max-width:680px){
  .message{
    width: 80%;
    position: fixed;
    left: 0;
    margin-left: 10%;
    padding: 0.5rem;
  }
}
</style>